var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.80371C10.5 4.03711 10.4988 3.53703 10.4727 3.15332C10.4474 2.78328 10.4037 2.63179 10.3701 2.55078C10.1973 2.13383 9.86617 1.80267 9.44922 1.62988C9.36821 1.59633 9.21673 1.55261 8.84668 1.52734C8.46297 1.50116 7.96289 1.5 7.19629 1.5H4.80371C4.03711 1.5 3.53703 1.50116 3.15332 1.52734C2.78328 1.55261 2.63179 1.59633 2.55078 1.62988C2.13383 1.80267 1.80267 2.13383 1.62988 2.55078C1.59633 2.63179 1.55261 2.78328 1.52734 3.15332C1.50116 3.53703 1.5 4.03711 1.5 4.80371V14.0459L6 11.2402L10.5 14.0459V4.80371ZM12 16H10.7988L6 13.0078L1.20117 16H6.24303e-09V4.80371C-4.37355e-07 3.49804 -0.000234783 2.76353 0.163086 2.20605L0.244141 1.97656C0.548914 1.24109 1.11588 0.647702 1.83203 0.308594L1.97656 0.244141C2.41798 0.0612996 2.94841 0.0153296 3.81543 0.00390625L4.80371 0H7.19629C8.68845 0 9.43492 0.000367656 10.0234 0.244141C10.8078 0.569161 11.4308 1.19223 11.7559 1.97656C11.9996 2.56508 12 3.31155 12 4.80371V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAction);
export default __webpack_public_path__ + "static/media/bookmarkAction.9a4a47efd108cc1041eafd20cb69061f.svg";
export { ForwardRef as ReactComponent };